import React from 'react';

export function FacialHygiene() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">HIGIENE FACIAL</h1>
      </div>

      <div className="grid grid-cols-1 gap-4">
        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <p className="text-gray-600">
              La higiene facial es el primer paso si quieres empezar a cuidarte.
              Se trata de un básico del cuidado facial que tiene como objetivo limpiar la piel en profundidad, favorecer la renovación celular y recuperar la hidratación. No es un tratamiento agresivo, por lo que podrás realizarlo con cierta frecuencia y utilizarlo como tratamiento de mantenimiento.
              Si quieres potenciar aún más el resultado de tu higiene facial solo tienes que añadir uno o varios de los suplementos que encontrarás al final.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Higiene facial sencilla</h2>
            <p className="text-gray-600">
              La higiene facial sencilla está pensada especialmente para pieles muy jóvenes, que quieren empezar a cuidarse y que nunca se han realizado un tratamiento profesional.
              Se trata de una sesión ligera que incluye los pasos básicos de una higiene facial y asesoramiento sobre cómo cuidarte también en casa, si quieres.
              Incluye depilación de cejas y/o labio.
              No incluye masaje facial.
              <br /><br />
              <strong>Duración:</strong> 1 hora.
              <br />
              <strong>Precio:</strong> 33€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Higiene facial profunda</h2>
            <p className="text-gray-600">
              La higiene facial profunda puede adaptarse a cualquier tipo de piel y de necesidad que tengas.
              Se trata de una sesión muy completa que incluye masaje facial y asesoramiento sobre cómo cuidarte también en casa, si quieres.
              Con una sola sesión conseguirás una piel limpia, fresca, luminosa e hidratada. Incluye depilación de cejas y/o labio.
              <br /><br />
              <strong>Duración:</strong> 1 h 30 min.
              <br />
              <strong>Precio:</strong> 38€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Suplementos</h2>
            <p className="text-gray-600">
              <strong>+15€</strong> 15 min extra de masaje facial<br />
              <strong>+16€</strong> Mascarilla de alginatos<br />
              <strong>+6€</strong> Ampolla de colágeno y elastina
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}